/* Style and layout */
export const LABEL_TEXT_COLOR = '#1F1D1C'
export const ROUTE_ICON_SIZE_PX = 32

/* Routes */
export const SETTINGS_ROUTES = {
  solarPriority: 'solar-priority',
  badges: 'badges',
  wallbox: 'wallbox',
  storage: 'storage',
  boiler: 'boiler',
  manageUsers: 'manage-users',
} as const

export const APP_NAME = 'flow'
